(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/brand-cubes/assets/javascripts/brand-cubes.js') >= 0) return;  svs.modules.push('/components/accountservices-react/brand-cubes/assets/javascripts/brand-cubes.js');

'use strict';

svs = svs || {};
svs.accountservices_react = svs.accountservices_react || {};
svs.accountservices_react.brand_cubes = svs.accountservices_react.brand_cubes || {};
const {
  BrandCube
} = svs.components.lbUi.brandCube;
const BrandCubes = function () {
  let {
    productId
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const momangProcuctId = 10004;
  const productIds = [72, 7, 10001, 45, 2, 8, 6, 22, 10003, 28, 1, 25];
  const size = svs.core.detect.formfactor.mobile() ? 60 : 90;
  const style = {
    '--size': "".concat(size, "px")
  };
  let productsToShow = [];
  if (productId && productIds.includes(productId) || productId === momangProcuctId) {
    productsToShow = [productId, productId, productId];
  } else {
    const uniqueProductIds = Array.from(new Set(productIds));
    while (productsToShow.length < 3 && uniqueProductIds.length > 0) {
      const idx = Math.floor(Math.random() * uniqueProductIds.length);
      productsToShow.push(uniqueProductIds.splice(idx, 1)[0]);
    }
  }
  return productsToShow.map((id, i) => React.createElement("div", {
    className: "brand-cube-wrapper brand-cube-wrapper-".concat(i),
    key: Math.random()
  }, React.createElement(BrandCube, {
    productId: id,
    style: style
  })));
};
svs.accountservices_react.brand_cubes.BrandCubes = BrandCubes;

 })(window);